import { useSyncExternalStore } from "react";

/**
 * Tiny global store for "workspace mode" (spatial design tools such as Riggdesign): collapsed global sidebar and
 * fullscreen. Kept outside React state so AppShell and pages can share it without prop drilling.
 */
const KEY = "si_sidebar_collapsed";
let state = {
  collapsed: (() => { try { const v = localStorage.getItem(KEY); return v === null ? null : v === "1"; } catch { return null; } })(), // null = follow route default
  fullscreen: false,
  mobileNav: 0, // counter – a workspace page can ask the shell to open the mobile navigation
};
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export const workspace = {
  get: () => state,
  setCollapsed(v) {
    state = { ...state, collapsed: v };
    try { v === null ? localStorage.removeItem(KEY) : localStorage.setItem(KEY, v ? "1" : "0"); } catch { /* ignore */ }
    emit();
  },
  setFullscreen(v) {
    state = { ...state, fullscreen: v };
    emit();
  },
  openMobileNav() {
    state = { ...state, mobileNav: state.mobileNav + 1 };
    emit();
  },
  subscribe(l) { listeners.add(l); return () => listeners.delete(l); },
};

export function useWorkspace() {
  return useSyncExternalStore(workspace.subscribe, workspace.get, workspace.get);
}

/** Routes that are spatial workspaces (sidebar collapses to icons, global topbar hides). */
export const isWorkspacePath = (pathname) => /\/riggdesign\/?$/.test(pathname || "");
